import { head, second } from "./array.js";
import { complement, pipe } from "./composition.js";
import { pairRight } from "./juxt.js";
import { map } from "./map.js";
import { isPromise } from "./promise.js";
export const filter = (f) => 
// @ts-expect-error typing head is hard.
pipe(map(pairRight(f)), (array) => array.filter(second), map(head));
export const find = (predicate) => (xs) => {
    const asyncResults = [];
    for (const x of xs) {
        const result = predicate(x);
        if (isPromise(result)) {
            asyncResults.push(result.then((predicateResult) => new Promise((resolve, reject) => predicateResult ? resolve(x) : reject(new Error("failed check")))));
        }
        else if (result)
            return x;
    }
    // @ts-expect-error ts cannot infer
    return (asyncResults.length)
        ? Promise.any(asyncResults).catch(() => undefined)
        : undefined;
};
export const remove = (f) => 
// @ts-expect-error compiler cannot infer
filter(complement(f));
const toContainmentCheck = (xs) => {
    const set = new Set(xs);
    return (k) => set.has(k);
};
export const intersectBy = (f) => (arrays) => arrays.reduce((current, next) => current.filter(pipe(f, toContainmentCheck(next.map(f)))));
export const removeNulls = (x) => x.filter((x) => x !== null);
